<template>
  <section>
    <!-- Componentes externos -->
    <v-card>
      <v-tabs centered color="primary" dark icons-and-text>
        <v-tabs-slider color="cyan"></v-tabs-slider>
        <v-tab href="#tab-1" v-if="this.$util.permisoRol([32,34])">
          Servidores públicos
          <span class="material-symbols-outlined">
            person
          </span>
        </v-tab>

        <v-tab href="#tab-2" v-if="this.$util.permisoRol([128])"> 
          Pasantes
          <span class="material-symbols-outlined">
            school
          </span>
        </v-tab>
        <!-- <v-tab href="#tab-3">
          Consultores
          <span class="material-symbols-outlined">
            engineering
          </span>
        </v-tab> -->
        <v-tab-item :value="'tab-1'">
          <v-card flat>
            <v-card-text>
              <h3 class="primary--text">
                <span class="material-symbols-outlined">
                  person
                </span>
                Servidores públicos
              </h3>
              <ListadoMovilidad :l_id_tipo_persona="[1]" />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item :value="'tab-2'">
          <v-card flat>
            <v-card-text>
              <h3 class="primary--text">
                <span class="material-symbols-outlined">
                  school
                </span>
                Pasantes
              </h3>
              <ListadoMovilidad :l_id_tipo_persona="[3]" />
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </section>
</template>

<script>
import CrearPersona from "./dialogs/CrearPersona"; // Componente de creación y actualización
import EditarPersona from "./dialogs/EditarPersona"; // Componente de Editar persona
import AprobarMovilidad from "./dialogs/AprobarMovilidad"; // Componente de Aprobar Movilidad persona
import ListadoMovilidad from './components/ListadoMovilidad.vue';

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [],
  // Definición de componentes importados
  components: {
    CrearPersona,
    EditarPersona,
    AprobarMovilidad,
    ListadoMovilidad
  },
  // Variables iniciales del componente
  data() {
    return {
      url: "vListaPersonals",
      graphql: true,
      // Cabecera de la tabla
      headers: [
        { text: "Número de documento", value: "nro_doc", align: "center" },
        { text: "Ítem", value: "item", align: "center" },
        { text: "Nombre completo", value: "nombre", align: "center" },
        { text: "Unidad", value: "unidad", align: "center" },
        {
          text: "Fecha de incorporación",
          value: "fecha_ingreso",
          align: "center"
        },
        { text: "Estado", value: "id_estado", align: "center" },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
        id_persona
        id_estado
        nro_doc
        nro_complemento
        item
        nombre
        unidad
        fecha_ingreso
        cargo
        id_cargo
        id_puesto
        id_item
        id_unidad
        id_movilidad
        estado
        activo_pasivo
      `,
      filters: [
        {
          field: "nro_doc",
          label: "Número de documento",
          type: "text",
          typeG: "String"
        },
        {
          field: "item",
          label: "Ítem",
          type: "number",
          typeG: "String"
        },
        {
          field: "nombre",
          label: "Nombre completo",
          type: "text",
          typeG: "String"
        },
        {
          field: "unidad",
          label: "Unidad",
          type: "text",
          typeG: "String"
        },
        {
          field: "fecha_ingreso",
          label: "Fecha de incorporación",
          type: "text",
          typeG: "String"
        },
        {
          field: "activo_pasivo",
          label: "Estado",
          type: "text",
          typeG: "String"
          // items: [
          //   { value: "", text: "TODOS" },
          //   { value: 1, text: "Alta" },
          //   { value: 2, text: "Baja" },
          //   { value: 5, text: "Pendiente" }
          // ]
        }
      ],
      respuestaFuncion: ["usuario", "correo", "contraseña"],
      respuestaFuncion1: ["usuario", "correo", "contraseña"],
      dialog: false
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [84,128]; // ID's de roles permitidos (84:Molivilidad RRHH)
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }

    this.$bus.$on("closeDialog", () => {
      this.updateList();
    });
    this.$bus.$on("closeDialogCreado", item => {
      this.respuestaFuncion = item.split("-");
      this.dialog = true;
    });
  },
  // Métodos y funciones del componente
  methods: {
    movilidad(item) {
      this.$bus.$emit("openDialogMovilidad", item);
    },
    editarPersona(item) {
      this.$bus.$emit("openDialogEditarPersona", item);
    },
    aprobarMovilidad(item) {
      this.$bus.$emit("openDialogAprobarMovilidad", item);
    },
    crearPersona() {
      this.$bus.$emit("openDialogCrearPersona");
    },
    close() {
      this.respuestaFuncion = [];
      this.dialog = false;
    },

    async enviarMensaje() {
      let correo = await this.getMail();
      const token = this.$storage.get("token");
      const url = process.env.API_URL + "system/sendmail";
      //console.log(correo)
      correo.forEach(async element => {
        //  console.log(element.correo)
        try {
          let body = {
            mail: element.correo,
            asunto: "Recordatorio Movilidad",
            message: element.cuerpo //this.form.observacion,
          };

          const options = {
            method: "POST",
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
          };

          var data = await fetch(url, options);
          data = await data.json();
          if (data.mensaje == "Success") {
            this.$message.success("Se envio el correo");
          } else {
            this.$message.error(data.mensaje);
          }
        } catch (error) {
          console.log(error);
        }
      });
    },
    async getMail() {
      try {
        let res = await this.$service.graphql({
          query: `
					query{
                vVenceInterinatos{
                  rows{
                    id
                    id_usuario
                    id_persona
                    fecha_hasta
                    correo
                    cuerpo
                    
                  }
                }
              }
				`
        });
        //return res.persona.usuarios[0].correo;

        this.correosDisponibles = res.vVenceInterinatos.rows;
        this.loading = false;
        return this.correosDisponibles;
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/movilidad/Index.vue